import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import PageTitle from '@/components/v2/PageTitle.vue';
import PaymentMethod from '@/plugins/graphql/queries/v2/payment-methods.gql';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
import Paginator from '@/components/v2/Paginator.vue';
import BaseSubtitle from '@/components/v2/BaseSubtitle';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import ActionButton from '@/components/action_button/Index.vue';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import CardItem from '@/components/v2/CardItem.vue';
import PaymentPreferencesDetails from '@/views/v2/PaymentPreferencesDetails.vue';
import ToggleConfirmationDialog from '@/components/v2/ToggleConfirmationDialog.vue';
let PaymentPreferences = class PaymentPreferences extends Mixins(FormMixin, ViewportSizeMixin, PaginatorMixin, CleverTapEventsMixin, RouterParamsAppMixin) {
    constructor() {
        super(...arguments);
        this.resetPagination = false;
        this.selectedAutomation = null;
        this.firstCursor = null;
        this.defaultPaymentMethod = null;
    }
    get detailStyle() {
        if (this.smAndUp) {
            return 'width: 80%';
        }
        return '';
    }
    get maskedNumber() {
        const vm = this;
        if (vm.defaultPaymentMethod &&
            vm.defaultPaymentMethod.ewallet &&
            vm.defaultPaymentMethod.ewallet.account.account_details) {
            const number = vm.defaultPaymentMethod.ewallet.account.account_details;
            const maskedSection = '*'.repeat(6);
            const lastFour = number.slice(0, number.length - 6);
            return lastFour + maskedSection;
        }
        if (vm.defaultPaymentMethod && vm.defaultPaymentMethod.directDebit) {
            return this.maskExceptLastFour(vm.defaultPaymentMethod.directDebit.bank_account.masked_bank_account_number);
        }
        if (vm.defaultPaymentMethod && vm.defaultPaymentMethod.card) {
            return this.maskExceptLastFour(vm.defaultPaymentMethod.card.card_information.masked_card_number);
        }
        return '';
    }
    maskExceptLastFour(number) {
        if (number) {
            const maskedSection = '*'.repeat(number.length - 4);
            const lastFour = number.slice(-4);
            return maskedSection + lastFour;
        }
        return '';
    }
};
__decorate([
    Mutation('showConfirmationDialog')
], PaymentPreferences.prototype, "showConfirmationDialog", void 0);
__decorate([
    Mutation('hideConfirmationDialog')
], PaymentPreferences.prototype, "hideConfirmationDialog", void 0);
PaymentPreferences = __decorate([
    Component({
        components: {
            PageTitle,
            BaseSubtitle,
            ActionButton,
            Paginator,
            ConfirmationDialog,
            CardItem,
            PaymentPreferencesDetails,
            ToggleConfirmationDialog,
        },
        apollo: {
            savedPaymentMethods: {
                query: PaymentMethod,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                fetchPolicy: 'cache-and-network',
                update(data) {
                    const methods = data.fetchPaymentMethods;
                    const defaultPay = methods.find((method) => method.isDefault);
                    this.defaultPaymentMethod = defaultPay;
                    return methods;
                },
                skip() {
                    return !this.appUUID;
                },
            },
        },
    })
], PaymentPreferences);
export default PaymentPreferences;
